import { logger } from '@app/utils/logger'
import { useEffect, useMemo } from 'react'

declare global {
  interface Window {
    __elfsightScriptLoadingPromise?: Promise<void>
  }
}

type Props = {
  appId?: string
  className?: string
}

const ELFSIGHT_SRC = 'https://elfsightcdn.com/platform.js'

const ElfsightLinkedInFeed = ({
  appId = '8a01b461-2e26-46d0-965f-47de4da5c798',
  className,
}: Props) => {
  const widgetClass = useMemo(() => `elfsight-app-${appId}`, [appId])

  useEffect(() => {
    if (typeof document === 'undefined') return

    if (!window.__elfsightScriptLoadingPromise) {
      window.__elfsightScriptLoadingPromise = new Promise<void>((resolve, reject) => {
        const existing = document.querySelector<HTMLScriptElement>(`script[src="${ELFSIGHT_SRC}"]`)
        if (existing) {
          resolve()
          return
        }

        const script = document.createElement('script')
        script.src = ELFSIGHT_SRC
        script.async = true
        script.onload = () => resolve()
        script.onerror = () => reject(new Error('Failed to load Elfsight platform.js'))
        document.body.appendChild(script)
      })
    }

    window.__elfsightScriptLoadingPromise.catch(() => {
      logger.error('Elfsight script failed to load')
    })
  }, [])

  return (
    <div className={className}>
      <div className={widgetClass} data-elfsight-app-lazy />
    </div>
  )
}

export { ElfsightLinkedInFeed }
